import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import reportWebVitals from './reportWebVitals';
import Home from "./pages/Home";
import Login from './pages/Login';
import Main from "./pages/Main";
import ErrorPage from "./pages/Error-page";
import Followings from "./pages/Followings";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './resources/bootstrap-custom.scss';
import './resources/fmf.css';
import RedirectMastodon from "./pages/RedirectMastodon";
import RedirectPixelfed from "./pages/RedirectPixelfed";
import './resources/fonts/Lato/Lato-Bold.ttf';
import About from "./pages/About";
import Logout from "./pages/Logout";
import GA4React from "ga-4-react";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "login",
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: "main",
    element: <Main />,
    errorElement: <ErrorPage />,
  },
  {
    path: "followings",
    element: <Followings />,
    errorElement: <ErrorPage />,
  },
  {
    path: "redirect-mastodon",
    element: <RedirectMastodon />,
    errorElement: <ErrorPage />,
  },
  {
    path: "redirect-pixelfed",
    element: <RedirectPixelfed />,
    errorElement: <ErrorPage />,
  },
  {
    path: "about",
    element: <About />,
    errorElement: <ErrorPage />,
  },
  {
    path: "logout",
    element: <Logout />,
    errorElement: <ErrorPage />,
  },
  
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  //<React.StrictMode>
    <RouterProvider router={router} />
  //</React.StrictMode>
);

try {
  setTimeout(_ => {
    const ga4react = new GA4React("G-HCEH7PDZN8");
    ga4react.initialize().catch(err => console.error(err));
  }, 4000);
} catch (err) {
      console.error(err);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();